export const API_URL = 'https://dean.nmcelogbook.com/api/';
// export const API_URL = 'http://localhost:5206/api/';

export const LoginUrl = API_URL+'auth/login';
export const getDashboard = API_URL+'acadmic/dashboard';
export const getRoles = API_URL+'acadmic/getRoles';
export const getAllUserWithPremission = API_URL+'acadmic/roleWithPremission';
export const getAllStudents = API_URL+'acadmic/getAllStudents';
export const getStudentDashUrl = API_URL+'acadmic/getStudentDash';
export const getMenu = API_URL+'acadmic/getMenu';
export const getStaffAll = API_URL+'acadmic/getStaffAll';
export const getDepartments = API_URL+'acadmic/getDepartments';
export const getElogRoles = API_URL+'acadmic/getElogRoles';


export const getAetcom = API_URL+'acadmic/getAetcom';
export const getApprisal = API_URL+'acadmic/getApprisal';
export const getSkills = API_URL+'acadmic/getSkills';
export const getReports = API_URL+'acadmic/getReports';
export const addSkills = API_URL+'acadmic/addSkills';

export const actionOnStaff = API_URL+'acadmic/actionOnStaff';
export const getInstituteList = API_URL+'acadmic/getInstituteList';
export const staffAction = API_URL+'acadmic/actionStaff';
export const deleteStaff = API_URL+'acadmic/deleteStaff';
export const getStaffDetails = API_URL+'acadmic/getStaffDetails';
export const updateStaffDetails = API_URL+'acadmic/updateStaffDetails';


export const getMyProfile = API_URL+'acadmic/getMyProfile';
export const getCompetencies = API_URL+'acadmic/getCompetencies';





export const affiliateLogin = API_URL+'affiliate/login'
export const GET_COUPON = API_URL+'affiliate/coupon'
export const GET_ALL_USER = API_URL+'affiliate/allUser'
export const UPDATE_AFFILIATE_PROFILE = API_URL+'affiliate/updateProfile'

export const GET_SETUP = API_URL+'acadmic/setup'
export const CREATE_SKILLS = API_URL+"acadmic/skills/create"
